var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellableProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 5 C 7.1364058 5 6 6.1364058 6 7.5 L 6 14.5 C 6 15.692499 6.8698775 16.712342 8 16.949219 L 8 36.5 C 8 40.071938 10.928062 43 14.5 43 L 33.5 43 C 37.071938 43 40 40.071938 40 36.5 L 40 16.949219 C 41.130122 16.712342 42 15.692499 42 14.5 L 42 7.5 C 42 6.1364058 40.863594 5 39.5 5 L 8.5 5 z M 9 8 L 39 8 L 39 14 L 38.5 14 L 9.5 14 L 9 14 L 9 8 z M 11 17 L 37 17 L 37 36.5 C 37 38.450062 35.450062 40 33.5 40 L 14.5 40 C 12.549938 40 11 38.450062 11 36.5 L 11 17 z M 19.5 21 A 1.50015 1.50015 0 1 0 19.5 24 L 28.5 24 A 1.50015 1.50015 0 1 0 28.5 21 L 19.5 21 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellableProduct);
export default __webpack_public_path__ + "static/media/sellableProduct.b150ed1bcdd9ee348b2353f245cc6c0f.svg";
export { ForwardRef as ReactComponent };